import { css } from "lit";

export const styles = css`
  @keyframes flourish {
    0% {
      transform: scale(1);
      background-color: transparent;
    }
    50% {
      transform: scale(1.05);
      background-color: rgb(0 123 255 / 0.1);
    }
    100% {
      transform: scale(1);
      background-color: transparent;
    }
  }

  .social-media-item {
    display: grid;
    align-items: center;
    width: 100%;
    padding: var(--sds-size-space-300) var(--sds-size-space-400);
    border: 2px solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-400);
    background-color: var(--sds-color-background-default-tertiary);
    text-align: left;
    overflow: hidden;
    box-sizing: border-box;

    grid-template:
      "drag icon content cta" auto
      / auto auto 1fr auto;
    gap: var(--sds-size-space-400);
  }

  .social-icon {
    grid-area: icon;
    width: 32px;
    height: 32px;
    border-radius: var(--sds-size-radius-full);
    object-fit: cover;
  }

  .content-section {
    grid-area: content;
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-150);
    min-width: 0; /* Allow content to shrink */
  }

  .platform-name {
    margin: 0;
    color: var(--sds-color-text-default-tertiary);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-label-size-small);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
  }

  .social-link {
    margin: 0;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cta-section {
    grid-area: cta;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .editable-link {
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.4;
    width: 100%;
    height: 22px;
    outline: none;
  }

  .editable-link::placeholder {
    color: var(--sds-color-text-default-secondary);
    opacity: 0.8;
  }

  .editable-link:focus {
    background-color: var(--sds-color-background-default-secondary);
    border-radius: var(--sds-size-radius-200);
    padding: var(--sds-size-space-100) var(--sds-size-space-200);
    margin: calc(-1 * var(--sds-size-space-100)) calc(-1 * var(--sds-size-space-200));
  }

  .editable-link.error {
    border: 1px solid var(--sds-color-border-danger-default);
    border-radius: var(--sds-size-radius-200);
    padding: var(--sds-size-space-100) var(--sds-size-space-200);
    margin: calc(-1 * var(--sds-size-space-100)) calc(-1 * var(--sds-size-space-200));
    outline: none;
  }

  .editable-link.error:focus {
    border: 1px solid var(--sds-color-border-danger-default);
    box-shadow: 0 0 0 2px var(--sds-color-border-danger-default-alpha);
  }

  .error-message {
    color: var(--sds-color-text-danger-default);
    font-size: var(--sds-typography-body-size-small);
    font-family: var(--sds-typography-family-body);
    margin-top: var(--sds-size-space-200);
    line-height: 1.4;
  }

  .social-media-item.add-button-item {
    cursor: pointer;
    padding: var(--sds-size-space-400);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    background-color: var(--sds-color-background-default-secondary);
    transition: all 0.2s ease;
  }

  .social-media-item.add-button-item:hover {
    border-color: var(--sds-color-border-default-primary);
    background-color: var(--sds-color-background-default-secondary);
  }

  .social-media-item.add-button-item:focus {
    outline: 2px solid var(--sds-color-border-focus);
    outline-offset: 2px;
  }

  .add-text {
    color: var(--sds-color-text-default-tertiary);
    font-family: var(--sds-typography-family-body);
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-regular);
    line-height: 1.4;
  }

  .add-button-item .platform-name {
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title);
    font-size: var(--sds-typography-body-size-large);
    font-weight: var(--sds-typography-weight-medium);
    line-height: 1;
  }

  /* Modern CSS-only animations with height + opacity staggered timing */
  .social-media-item {
    max-height: 200px; /* Reasonable max height for social media items */
    opacity: 1;
    overflow: hidden;
    transition:
      background-color 0.2s ease,
      max-height 150ms ease-out,
      opacity 150ms ease-out 150ms; /* 150ms delay for opacity */
  }

  /* Initial state for entering items */
  .social-media-item.entering {
    max-height: 0;
    opacity: 0;
  }

  /* Respect user motion preferences */
  @media (prefers-reduced-motion: reduce) {
    .social-media-item {
      transition: none;
    }

    .social-media-item.entering {
      max-height: 200px;
      opacity: 1;
    }
  }

  .delete-button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: var(--sds-size-space-200);
    border-radius: var(--sds-size-radius-200);
    color: var(--sds-color-text-default-secondary);
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .delete-button:hover {
    background-color: var(--sds-color-background-danger-secondary);
    color: var(--sds-color-text-danger-default);
  }

  .delete-button:focus {
    outline: 2px solid var(--sds-color-border-focus);
    outline-offset: 2px;
  }

  /* Draggable item class for DnD controller */
  .draggable-item {
    position: relative;
    cursor: grab;
    transition:
      transform 0.15s ease,
      opacity 0.15s ease;
  }

  .draggable-item.dragging {
    cursor: grabbing;
    opacity: 0.6;
    transform: scale(0.95);
  }

  /* Flourish effect */
  .flourish-active {
    animation: flourish 0.6s ease-out;
  }

  /* Wrapper to contain both visual handle and hit area */
  .item-card-dnd-handle-wrapper {
    position: relative;
    align-self: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item-card-dnd-handle-hitarea {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 44px;
    height: 44px;
    z-index: 1;
    cursor: grab;
    touch-action: none;
  }
  .item-card-dnd-handle-hitarea.pointer-down {
    cursor: grabbing;
  }
  .item-card-dnd-handle {
    position: relative;
    z-index: 0;
    align-self: center;
    color: var(--sds-color-icon-neutral-tertiary);
    padding: 4px;
    border-radius: 4px;
    transition: all 0.2s ease;
    min-height: 24px;
    min-width: 24px;
    user-select: none;
    pointer-events: none;
  }
  .item-card-dnd-handle-wrapper:hover .item-card-dnd-handle {
    background-color: var(--sds-color-background-default-secondary);
    color: var(--sds-color-icon-neutral-secondary);
  }
  .item-card-dnd-handle-hitarea.pointer-down ~ .item-card-dnd-handle {
    background-color: var(--sds-color-background-brand-subtle);
    color: var(--sds-color-icon-brand-default);
    transform: scale(1.1);
  }

  @media (max-width: 767px) {
    .social-media-item.add-button-item {
      min-height: 44px; /* iOS touch target minimum */
    }

    .add-text {
      font-size: var(--sds-typography-body-size-large);
    }

    .delete-button {
      min-width: 44px; /* iOS touch target minimum */
      min-height: 44px;
    }
  }
`;
